import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

/** Modules */
import {
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
  MatToolbarModule,
  MatSnackBarModule,
  MatListModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatTabsModule,
  MatTooltipModule,
  MatSidenavModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatCardModule,
  MatTableModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSlideToggleModule,
} from "@angular/material";
import { AppointmentRoutingModule } from "./appointment-routing.module";
import { OaDirectoryModule } from "../open-age-ng/directory/oa-directory.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';


/**  Pages*/
import { AppointmentsComponent } from "./appointments/appointments.component";
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentNewComponent } from "./appointment-new/appointment-new.component";
import { AppointmentViewComponent } from "./appointment-view/appointment-view.component";

/** Components */
import { AddPatientsDialogComponent } from "./components/add-patients-dialog/add-patients-dialog.component";
import { OaWelcomeModule } from '../open-age-ng/welcome/oa-welcome.module';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { AppointmentReportsComponent } from './components/appointment-reports/appointment-reports.component';
import { QuickAddPatientsDialogComponent } from './components/quick-add-patients-dialog/quick-add-patients-dialog.component';
import { PatientsModule } from "../patients/patients.module";
import { OaInsightModule } from "../open-age-ng/insight/oa-insight.module";

@NgModule({
  declarations: [
    AppointmentsComponent,
    AppointmentNewComponent,
    AppointmentViewComponent,
    AddPatientsDialogComponent,
    QuickAddPatientsDialogComponent,
    AppointmentComponent,
    MonthPickerComponent,
    AppointmentReportsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    MatTooltipModule,
    MatSidenavModule,
    OaDirectoryModule,
    OaWelcomeModule,
    OaInsightModule,
    AppointmentRoutingModule,
    SharedModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatCardModule,
    MatListModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    NgxMaterialTimepickerModule,
    PatientsModule
  ],
  entryComponents: [AddPatientsDialogComponent, QuickAddPatientsDialogComponent],
})
export class AppointmentModule { }
